export default {
  path: '/verification',
  name: 'verification',
  component: () => import(/* webpackChunkName: "user" */ '@/views/Home'),
  children: [
    {
      path: '/verification/email-sent',
      name: 'verification.email-sent',
      component: () =>
        import(
          /* webpackChunkName: "email-sent" */ '@/views/Home/Verification/EmailSent'
        ),
    },
    {
      path: '/verification/:code',
      name: 'verification.code',
      component: () =>
        import(/* webpackChunkName: "code" */ '@/views/Home/Verification/Code'),
    },
  ],
}
